var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.247437,
    y: 0.611816,
    width: 54.8829,
    height: 54.8829,
    rx: 4,
    fill: "#E83E8C",
    fillOpacity: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 26H27.5C26.6716 26 26 26.6716 26 27.5C26 28.3284 26.6716 29 27.5 29H28.5C29.3284 29 30 29.6716 30 30.5C30 31.3284 29.3284 32 28.5 32H26M28 25V26M28 32V33M34 29H34.01M22 29H22.01M18 25.2L18 32.8C18 33.9201 18 34.4802 18.218 34.908C18.4097 35.2843 18.7157 35.5903 19.092 35.782C19.5198 36 20.0799 36 21.2 36L34.8 36C35.9201 36 36.4802 36 36.908 35.782C37.2843 35.5903 37.5903 35.2843 37.782 34.908C38 34.4802 38 33.9201 38 32.8V25.2C38 24.0799 38 23.5198 37.782 23.092C37.5903 22.7157 37.2843 22.4097 36.908 22.218C36.4802 22 35.9201 22 34.8 22L21.2 22C20.0799 22 19.5198 22 19.092 22.218C18.7157 22.4097 18.4097 22.7157 18.218 23.092C18 23.5198 18 24.0799 18 25.2ZM34.5 29C34.5 29.2761 34.2761 29.5 34 29.5C33.7239 29.5 33.5 29.2761 33.5 29C33.5 28.7239 33.7239 28.5 34 28.5C34.2761 28.5 34.5 28.7239 34.5 29ZM22.5 29C22.5 29.2761 22.2761 29.5 22 29.5C21.7239 29.5 21.5 29.2761 21.5 29C21.5 28.7239 21.7239 28.5 22 28.5C22.2761 28.5 22.5 28.7239 22.5 29Z",
    stroke: "#E83E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.d5c3229d8a3a03e2ea7b890687265759.svg";
export { ForwardRef as ReactComponent };